import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useAgoraRecordingApi() {
  const callApi = useApiCall();

  const startRecording = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.AGORA_RECORDING.START, data, onSuccess, onError);
  };

  const stopRecording = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.AGORA_RECORDING.STOP, data, onSuccess, onError);
  };

  const queryRecording = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.AGORA_RECORDING.QUERY, data, onSuccess, onError);
  };

  return {
    callStartRecording: startRecording,
    callStopRecording: stopRecording,
    callQueryRecording: queryRecording,
  };
}

export function useAgoraApi() {
  const callApi = useApiCall();

  const instantCall = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.AGORA.INSTANT_CALL, data, onSuccess, onError);
  };

  const getInstantCallDetails = (channel_name: string, onSuccess: Function, onError: Function) => {
    const payload = { channel_name, method: "GET" };
    callApi(SAGA_ACTIONS.AGORA.INSTANT_CALL, payload, onSuccess, onError);
  };

  return {
    callInstantCall: instantCall,
    callGetInstantCallDetails: getInstantCallDetails,
  };
}
